/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FieldRequireTypes,
    FieldRequireTypesFromJSON,
    FieldRequireTypesFromJSONTyped,
    FieldRequireTypesToJSON,
} from './';

/**
 * 
 * @export
 * @interface FailureStatusDto
 */
export interface FailureStatusDto {
    /**
     * 
     * @type {string}
     * @memberof FailureStatusDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FailureStatusDto
     */
    alternativeName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FailureStatusDto
     */
    isSpecialCase: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FailureStatusDto
     */
    isSealed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FailureStatusDto
     */
    isDefault: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FailureStatusDto
     */
    requiresWorkbookTask: boolean;
    /**
     * 
     * @type {FieldRequireTypes}
     * @memberof FailureStatusDto
     */
    requiresStateChangeReason: FieldRequireTypes;
}

export function FailureStatusDtoFromJSON(json: any): FailureStatusDto {
    return FailureStatusDtoFromJSONTyped(json, false);
}

export function FailureStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'alternativeName': !exists(json, 'alternativeName') ? undefined : json['alternativeName'],
        'isSpecialCase': json['isSpecialCase'],
        'isSealed': json['isSealed'],
        'isDefault': json['isDefault'],
        'requiresWorkbookTask': json['requiresWorkbookTask'],
        'requiresStateChangeReason': FieldRequireTypesFromJSON(json['requiresStateChangeReason']),
    };
}

export function FailureStatusDtoToJSON(value?: FailureStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'alternativeName': value.alternativeName,
        'isSpecialCase': value.isSpecialCase,
        'isSealed': value.isSealed,
        'isDefault': value.isDefault,
        'requiresWorkbookTask': value.requiresWorkbookTask,
        'requiresStateChangeReason': FieldRequireTypesToJSON(value.requiresStateChangeReason),
    };
}


